import { Component, Input, NgModule, OnInit } from '@angular/core';
import { BaseFormListComponent } from 'src/app/shared/components/base-form/base-form-list.component';
import { FaturamentoFormComponent } from './faturamento-form.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerComponent } from '../util/spinner/spinner.component';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Misc } from '../util/misc';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { Subject } from 'rxjs';
import { Faturamento } from 'src/app/models/faturamento.model';
import { FaturamentoPreDefinido } from 'src/app/models/faturamento-pre-definido.model';
import { FaturamentoService } from 'src/app/services/faturamento.service';
import { CalculoService } from 'src/app/services/calculo.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { UtilService } from 'src/app/services/util.service';
import * as constants from 'src/app/models/constants/constants';

@Component({
  selector: 'app-faturamento-list',
  templateUrl: './faturamento-list.component.html',
  styleUrls: ['./faturamento-list.component.scss']
})

export class FaturamentoListComponent extends BaseFormListComponent<Faturamento> implements OnInit {
  eventos: Faturamento[] = [];
  displayedColumns: string[] = ['delete', 'evento', 'percentual', 'valor', 'save'];
  dataSource = new MatTableDataSource<Faturamento>();
  loading = true;
  totalReceitaBruta: number;
  fat: Faturamento[] = null;
  inputsFat: Faturamento;
  updateAutomaticoFieldsEvent: Faturamento[];
  basicForm: UntypedFormGroup;
  manutencaoFaturamento: Faturamento = null;
  faturamentosPreDefinidos: FaturamentoPreDefinido[] = [];

  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();
  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean;
  @Input() hiddenResume: boolean;
  tipoDelivery: boolean;

  desabilitaIcones: boolean;
  estimativaTipo: number;
  miscService: Misc;

  constructor(
    private faturamentoService: FaturamentoService,
    protected calculoService: CalculoService,
    private authenticationService: AuthenticationService,
    private estimativaService: EstimativaService,
    private misc: Misc,
    private toastr: ToastrComponent,
    private fb: UntypedFormBuilder,
    private dialog: MatDialog,
    private utilService: UtilService) {
    super(faturamentoService);

    this.miscService = misc;
    this.createForm();
  }


  createForm() {
    this.basicForm = this.fb.group({
      faturamentoPreDefinido: [null]
    });

  }

  ngOnInit() {
    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe((result: any) => {

      this.estimativaTipo = result.estimativaTipoId

      if (this.estimativaTipo == 3) {
        this.somenteLeitura = false;
        this.tipoDelivery = true;
        this.hiddenResume;
      }

      if (this.estimativaTipo == 1 && !this.somenteLeitura) {
        this.somenteLeitura = false;
        this.desabilitaIcones = false;
      }

      if (this.estimativaTipo == 1 && this.somenteLeitura) {
        this.somenteLeitura = true;
        this.desabilitaIcones = true;
      }

      if (this.estimativaTipo == 3 && this.somenteLeitura) {
        this.somenteLeitura = false;
        this.desabilitaIcones = false;
      }

      this.estimativaService.getById(this.estimativaId).subscribe((estimativa: any) => {
        if (estimativa.statusId === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
          this.somenteLeitura = true;
        }
      });

      this.loading = true;

      this.faturamentoService.carregarListaFaturamentoPreDefinido(this.authenticationService.currentUserValue.id).subscribe(
        result => {
          this.faturamentosPreDefinidos = result.items;

          this.calculoService.calcularReceitaBrutaAdotado(this.estimativaId).subscribe(
            total => {
              this.totalReceitaBruta = total;
              this.carregarEventos();
            },
            error => {
              this.miscService.processError(error, 'Não foi possível carregar a lista de faturamentos pré definidos.');
              this.loading = false;
            }
          );
        },
        error => {
          this.miscService.processError(error, 'Não foi possível carregar a lista de faturamentos pré definidos.');
          this.loading = false;
        }
      );
    })


    this.resetFormSubject.subscribe(
      response => {
        if (response) {
          this.faturamentoService.recalcularFaturamento(this.estimativaId).subscribe(
            result => {
              this.calculoService.calcularReceitaBrutaAdotado(this.estimativaId).subscribe(
                total => {
                  this.totalReceitaBruta = total;
                  this.carregarEventos();
                },
                error => {
                  this.miscService.processError(error, 'Não foi possível carregar a lista de faturamentos pré definidos.');

                  this.loading = false;
                }
              );
            },
            error => {
              this.miscService.processError(error, 'Não foi possível recalcular o faturamento.');
            }
          );
        }
      }
    );
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(FaturamentoFormComponent, {
      width: '500px',
      data: { estimativaId: this.estimativaId, totalPercentual: this.getTotalPercentual() },
      panelClass: 'default-dialog-container'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.carregarEventos();
    });
  }

  excluir(id: number) {
    if (id > 0) {
      this.faturamentoService.delete(id).subscribe(() => {
        this.carregarEventos();
        this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro excluído com sucesso');
      });
    }
  }

  carregarEventos() {
    this.faturamentoService.getByEstimativa(this.estimativaId).subscribe(
      eventos => {
        this.eventos = eventos.items;

        //this.updateAutomaticoFieldsEvent = eventos.items;
        this.dataSource = new MatTableDataSource<Faturamento>(this.eventos);
      },
      error => {
        this.miscService.processError(error, 'Não foi possível carregar a lista de faturamentos da estimativa.');
      },
      () => {
        this.putParametrosAutomaticamento(this.updateAutomaticoFieldsEvent)
        this.loading = false;
      }
    );
  }

  async putParametrosAutomaticamento(itens) {
    if (itens) {
      for (let iterator of itens) {
        iterator.valor = (iterator.percentual / 100) * this.totalReceitaBruta;

        await this.faturamentoService
          .updateFaturamentoEspecifico(iterator)
          .subscribe()
      }
    }

    return;
  }

  getTotalPercentual() {
    return this.eventos.map(e => e.percentual).reduce((acc, value) => acc + value, 0);
  }

  getTotalValor() {
    return this.eventos.map(e => e.valor).reduce((acc, value) => acc + value, 0);
  }

  carregarFaturamentoPreDefinido() {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        titulo: 'Faturamento Pré-Definido',
        texto: 'Atenção! Essa ação irá substituir todo o faturamento atual pelo pré-definido. Confirma?'
      },
      panelClass: 'default-dialog-container'
    });

    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.loading = true;

          const faturamentoPreDefinido: FaturamentoPreDefinido = this.basicForm.value.faturamentoPreDefinido;

          if (faturamentoPreDefinido) {
            this.estimativaService.adicionarFaturamentoPreDefinido(this.estimativaId, faturamentoPreDefinido.id).subscribe(
              () => {
                this.carregarEventos();

                this.basicForm.reset();

                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Faturamento pré-definido carregado com sucesso.');
              }, error => {
                this.miscService.processError(error, 'Não foi possível adicionar o faturamento pré definido.');

                this.loading = false;
              }
            );
          }
        }
      }
    );
  }

  editar(evento) {
    this.manutencaoFaturamento = JSON.parse(JSON.stringify(evento));
    this.inputsFat = this.manutencaoFaturamento;
  }
  onCancel() {
    this.manutencaoFaturamento = null;
  }

  onUpdate() {
    this.onAtualizarAutomaticamente(this.inputsFat);
  }

  onAtualizarAutomaticamente(element: Faturamento) {
    const faturamento = {
      id: this.inputsFat.id,
      percentual: this.inputsFat.percentual,
      estimativaId: this.inputsFat.estimativaId,
      evento: this.inputsFat.evento,
      valor: this.inputsFat.valor
    }

    this.faturamentoService
      .updateFaturamentoEspecifico(faturamento)
      .subscribe(
        success => {
          this.carregarEventos();
          this.manutencaoFaturamento = null;
        }
      );
  }

  onCalcValor(element) {
    this.inputsFat.percentual = Number((Number(element) / this.totalReceitaBruta * 100).toFixed(2))
  }

  onCalcPer(element) {
    this.inputsFat.valor = Number(((Number(element) / 100) * this.totalReceitaBruta).toFixed(2));
  }
}
